import React from 'react';
import { useNavigate } from 'react-router-dom';
import apiClient from '../../api/api';
import MediaPlaceholder from './MediaPlaceholder';
import { useDataStore } from '../../stores/useDataStore';
import { buildWhatsappUrl } from '../../utils/whatsapp';

const AdBanner = ({ ad, imageUrl, defaultAssets }) => {
  const navigate = useNavigate();
  const assetsFromStore = useDataStore((state) => state.defaultAssets?.assets);
  const fetchDefaultAssets = useDataStore((state) => state.fetchDefaultAssets);

  React.useEffect(() => {
    if (!defaultAssets && !assetsFromStore) {
      fetchDefaultAssets?.();
    }
  }, [defaultAssets, assetsFromStore, fetchDefaultAssets]);

  const resolvedDefaultAssets = defaultAssets || assetsFromStore;

  const fallbackAd = ad || resolvedDefaultAssets?.adFallbacks?.[0] || null;
  const title = fallbackAd?.title || 'Publicidad Ágora';
  const mediaSource = fallbackAd?.imageUrl || imageUrl || resolvedDefaultAssets?.mediaAssets?.[0]?.url;

  const resolveTarget = () => {
    if (!fallbackAd) return null;
    const actionType = fallbackAd.actionType || 'url';

    if (actionType === 'whatsapp') {
      return buildWhatsappUrl({
        phone: fallbackAd.phone || fallbackAd.whatsappNumber || fallbackAd.contactPhone || fallbackAd.advertiser?.phone,
        title,
        customMessage: fallbackAd.whatsappMessage,
      });
    }

    if (actionType === 'internal') {
      return fallbackAd.internalPath || fallbackAd.actionValue || '/ads-center';
    }

    return fallbackAd.linkUrl || fallbackAd.actionValue || null;
  };

  const handleClick = async (event) => {
    event.preventDefault();

    if (fallbackAd?._id) {
      try {
        await apiClient.post(`/ads/${fallbackAd._id}/track`, { eventType: 'click' });
      } catch {
        // Silencioso para no afectar la navegación del usuario
      }
    }

    const target = resolveTarget();
    if (!target) return;

    if ((fallbackAd?.actionType || 'url') === 'internal') {
      navigate(target);
      return;
    }

    window.open(target, '_blank', 'noopener,noreferrer');
  };

  if (!mediaSource) return null;

  return (
    <div className="container px-0">
      <a href={resolveTarget() || '#'} onClick={handleClick} className="block">
        <MediaPlaceholder
          src={mediaSource}
          alt={title}
          fallbackAssets={resolvedDefaultAssets?.mediaAssets || []}
          className="w-full h-28 rounded-lg shadow-md object-cover"
        />
      </a>
    </div>
  );
};

export default AdBanner;
